import { X, Calendar, User, ShoppingBasket, Clock, ExternalLink, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { fmtLongDate, firstName } from "@/lib/rgApi";

/**
 * MarketDetailsModal — Vue détaillée d'un événement 🧺 Marché.
 *
 * Affiche :
 *   • Voyageur concerné
 *   • Date d'arrivée
 *   • Expérience(s) concernée(s) (icônes + labels)
 *   • Liste des achats à faire
 *   • Bouton pour modifier date/heure et lien fiche voyageur
 */
export default function MarketDetailsModal({ open, onClose, event, reservation, onEditTime, onDelete }) {
  if (!open || !event || !reservation) return null;
  const needs = event.needs || [];

  return (
    <>
      <div className="rg-modal-back" onClick={onClose} data-testid="rg-market-back" />
      <div className="rg-modal" role="dialog" aria-modal="true" data-testid="rg-market-modal">
        <div className="rg-modal-head">
          <div>
            <div className="rg-tiny">🧺 Marché · {event.date}</div>
            <div className="rg-modal-title">{firstName(reservation.name)}</div>
          </div>
          <button className="rg-icon-btn" onClick={onClose} data-testid="rg-market-close"><X size={18} /></button>
        </div>

        <div className="rg-modal-body">
          <div className="rg-modal-section">
            <div className="rg-market-line">
              <User size={13} />
              <span><b>{reservation.name}</b> · {reservation.people || "?"} personne(s)</span>
            </div>
            <div className="rg-market-line">
              <Calendar size={13} />
              <span>Arrivée le <b>{fmtLongDate(reservation.date_arrival)}</b></span>
            </div>
            <div className="rg-market-line">
              <Clock size={13} />
              <span>Marché <b>{fmtLongDate(event.date)}</b>{event.time ? ` · ${event.time}` : ""}</span>
            </div>
          </div>

          <hr className="rg-modal-sep" />

          <div className="rg-modal-section">
            <h4 className="rg-modal-subtitle">Expérience(s) concernée(s)</h4>
            {needs.length === 0 ? (
              <p className="rg-muted">Aucune expérience — le marché ne devrait pas exister.</p>
            ) : (
              needs.map((n, i) => (
                <div key={i} className="rg-market-need" data-testid={`rg-market-need-${n.key}`}>
                  <div className="rg-market-need-head">
                    <span className="rg-market-need-icon">{n.icon}</span>
                    <span className="rg-market-need-label">{n.label}</span>
                    {n.key === "petit_dejeuner" && n.form_received === false && (
                      <span className="rg-market-need-pending">🥐❓ formulaire à recevoir</span>
                    )}
                  </div>
                  <div className="rg-market-need-detail">
                    <ShoppingBasket size={12} />
                    <span>{n.need}</span>
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="rg-row" style={{ gap: 8, marginTop: 16, flexWrap: "wrap" }}>
            <button className="rg-btn" onClick={onEditTime} data-testid="rg-market-edit-time">
              <Clock size={13} /> Déplacer (date/heure)
            </button>
            <Link
              to={`/admin/gestion/voyageur/${reservation.id}`}
              className="rg-btn ghost"
              data-testid="rg-market-open-guest"
            >
              <ExternalLink size={13} /> Fiche voyageur
            </Link>
          </div>

          {onDelete && (
            <button
              className="rg-btn ghost"
              onClick={() => {
                if (window.confirm("Supprimer ce jour de marché ? La réservation et ses extras ne sont pas modifiés — vous pourrez le réafficher.")) onDelete();
              }}
              data-testid="rg-market-delete"
              style={{ marginTop: 10, color: "#b23b3b", borderColor: "#e3b7b7" }}
            >
              <Trash2 size={13} /> Supprimer ce jour de marché
            </button>
          )}
        </div>
      </div>
    </>
  );
}
